import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import './style.scss';
import { Shape } from '../../components';

const Page = ({ children, className, loading, referenceLoading, title, type, ...props }) => {
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = hasLoadingItems && referenceLoading.get('itemsStarted') !== referenceLoading.get('itemsFinished');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  const classes = classNames('Page', className);
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });

  return (
    <div className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
      <Shape type={type} />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}

export default connect(mapStateToProps)(Page);
